import React, { useContext, useMemo } from "react";
import CoursewareContext from "../../store";
import {
    CoursewareListItem,
    CoursewareType,
    CourseWareTypeList
} from "API/courseware";
import styles from "./index.module.scss";
import classNames from "classnames";
import CustomEmpty from "components/CustomEmpty";
import Opener from "./components/Opener";
import VideoViewer from "./components/VideoViewer";
import DocViewer from "../../../../../../../components/PreviewSourceModal/components/Viewer/Components/DocViewer";

export default function Viewer() {
    const { current, list } = useContext(CoursewareContext);

    const courseware = useMemo<CoursewareListItem | undefined>(() => {
        return list.find(item => item.id === current);
    }, [current, list]);

    // 没有课件
    if (!courseware) return null;

    // web365
    if (courseware.sourceFileEntity?.officeViewUrl) {
        return (
            <DocViewer
                className={styles.iframe}
                src={courseware.sourceFileEntity?.officeViewUrl}
            />
        );
    }

    // polyv
    if (courseware.sourceFileEntity?.useType === CoursewareType.polyv) {
        return <VideoViewer vid={courseware.sourceFileEntity?.viewUrl || ""} />;
    }

    // 图片
    if (
        CourseWareTypeList.pic.includes(
            courseware.sourceFileEntity?.fileType || ""
        )
    ) {
        return (
            <iframe
                className={styles.iframe}
                src={courseware.sourceFileEntity?.viewUrl}>
                Viewer
            </iframe>
        );
    }

    // 网页
    if (
        CourseWareTypeList.href.includes(
            courseware.sourceFileEntity?.fileType || ""
        )
    ) {
        return <Opener url={courseware.sourceFileEntity?.viewUrl} />;
    }

    // 视频
    if (
        CourseWareTypeList.video.includes(
            courseware.sourceFileEntity?.fileType || ""
        )
    ) {
        return (
            <>
                {courseware?.sourceFileEntity?.viewUrl?.includes("http") ? (
                    <video
                        controls
                        src={courseware.sourceFileEntity?.viewUrl}
                        className={styles.video}
                    />
                ) : (
                    <div className={styles.video}>
                        <VideoViewer
                            vid={courseware.sourceFileEntity?.viewUrl || ""}
                        />
                    </div>
                )}
            </>
        );
    }

    // 老文件office
    if (
        CourseWareTypeList.offices.includes(
            courseware.sourceFileEntity?.fileType || ""
        ) &&
        !courseware.sourceFileEntity?.officeViewUrl
    ) {
        return (
            <iframe
                className={styles.iframe}
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${courseware?.sourceFileEntity?.viewUrl}`}>
                Viewer
            </iframe>
        );
    }

    // 老文件pdf
    if (
        CourseWareTypeList.pdf.includes(
            courseware.sourceFileEntity?.fileType || ""
        )
    ) {
        return (
            <iframe
                className={styles.iframe}
                src={courseware?.sourceFileEntity?.viewUrl}>
                Viewer
            </iframe>
        );
    }

    // 不支持预览
    return (
        <div className={classNames(styles.empty)}>
            <CustomEmpty description="当前文件格式不支持预览, 请下载到本地查看" />
        </div>
    );
}
